import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api';
import App from './App.vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
Vue.use(VueCompositionAPI);

import router from './router'

new Vue({
    el: "#app",
    router,
    components: { App },
    template: "<App />"
});
